import { useState, useCallback } from 'react';

interface MobileSearchToggleProps {
  targetId: string;
}

/**
 * Magnifying-glass icon button that toggles visibility of a toolbar on mobile.
 * Only rendered on screens <= 767px (controlled by CSS class `mobile-search-toggle`).
 */
export function MobileSearchToggle({ targetId }: MobileSearchToggleProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = useCallback(() => {
    const target = document.getElementById(targetId);
    if (target) {
      target.classList.toggle('is-mobile-visible');
      setIsOpen((prev) => !prev);
    }
  }, [targetId]);

  return (
    <button
      type="button"
      className={`module-toolbar-button is-icon-only mobile-search-toggle${isOpen ? ' is-active' : ''}`}
      style={{ minHeight: 44, minWidth: 44, color: '#6b6560' }}
      onClick={handleToggle}
      title="Search"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    </button>
  );
}
